/**
 * Created by Jason on 2017-3-6.
 */
import '../../assets/lib/boostrap/css/bootstrap.css'
import '../../assets/lib/fontawesome/css/font-awesome.min.css';
import '../../assets/css/main.less'
import './index.less';

import '../../assets/lib/boostrap/js/bootstrap'
import '../../assets/js/main'
//分页
import '../../assets/lib/pagination/jquery.twbsPagination';
import '../../assets/js/animate'
import main from '../../assets/js/main';
import util from '../../assets/js/util';
//弹窗
import bootbox from '../../assets/lib/bootbox/bootbox';

const contractStatusArray = ['', '服务中', '服务中', '服务中', '已发送', '服务中', '延期完成', '服务中'];
let Month = new Date().getMonth()+1

function Banner(id, options) {
    var self = this;
    var $el = self.$el = $(id).eq(0);
    var $items = self.$items = $el.children();
    var len = self.len = $items.length;
    var index = self.index = 0;
    var $label = ['<span class="banner-labels">'];
    var i = 0;
    var $prev, $next;
    self.width = $el.outerWidth();
    if (len < 2) {
        return;
    }
    //label
    for (; i < len; i++) {
        $label.push('<i data-i="' + i + '"></i>');
    }
    $label.push('</span>');
    $el.append($label.join(''));
    self.$labels = $el.find('.banner-labels');
    self.$abelItems = self.$labels.children();
    self.$abelItems.eq(0).addClass('checked');
    self.$labels.on('click', function (e) {
        var $t = $(e.target);
        var i = $t.data('i');
        if (self.isScroll) {
            return;
        }
        switch (i) {
            case 'prev':
                self._scroll(self.index - 1);
                break;
            case 'next':
                self._scroll(self.index + 1);
                break;
            case undefined:
            case null:
                break;
            default:
                self._scroll(i);
        }
    });
    //是否自动滚动
    if (options.isAuto) {
        //是否暂停
        $el.on('mouseout', function () {
            self._auto();
        });
        $el.on('mouseover', function () {
            clearInterval(self.interval);
        });
        self._auto();
    }
    //上一页下一页
    if (options.isDir) {
        $prev = $('<span>').addClass('label-prev').data('i', 'prev').html('◀');
        $next = $('<span>').addClass('label-next').data('i', 'next').html('▶');
        self.$labels.prepend($prev);
        self.$labels.append($next);
    }
    self.options = options;
}

Banner.prototype = {
    construct: Banner,
    _auto: function () {
        var self = this;
        self.interval = setInterval(function () {
            self._scroll(self.index + 1, true);
        }, 4000);
    },
    _scroll: function (i, isAuto) {
        var self = this;
        var index;
        var $scrollIn;
        var $scrollOut, $labelIn, $labelOut;
        var options = self.options;
        var width = self.width;
        i = parseInt(i);
        if (i < 0) {
            if (!options.isLoop) {
                return;
            }
            index = self.len - 1;
        } else if (i >= self.len) {
            if (!options.isLoop) {
                return;
            }
            index = 0;
        } else {
            index = i;
        }
        if (index === self.index) {
            return;
        }
        $scrollIn = self.$items.eq(index);
        $scrollOut = self.$items.eq(self.index);
        $labelIn = self.$abelItems.eq(index);
        $labelOut = self.$abelItems.eq(self.index);
        self.isScroll = true;
        if (index > self.index || isAuto) {
            $scrollIn.css('left', width);
            animate({
                time: 400,
                curve: 'sineInOut'
            }, function (r) {
                $scrollIn.css('left', width - width * r);
                $scrollOut.css('left', -width * r);
                self.isScroll = false;
            });
        } else {
            $scrollIn.css('left', -width);
            animate({
                time: 400,
                curve: 'sineInOut'
            }, function (r) {
                $scrollIn.css('left', -width + width * r);
                $scrollOut.css('left', width * r);
                self.isScroll = false;
            });
        }
        $labelIn.addClass('checked');
        $labelOut.removeClass('checked');
        self.index = index;
    }
};


{
    let index = {
        queryObj: {
            pageNumber: 1,
            pageSize: 15
        },
        init(userData) {
            let _this = this;
            _this.companyId = localStorage.getItem('account.companyId');
            _this.$banner = $("#banner");
            _this.emptyHtml = `<p style="text-align: center">当前没有通知</p>`;
            _this.$noticeList = $("#notice-list");
            _this.$wrap = $(".task-container .waterfall")
            _this.userData = userData;
            _this.getNoticeList();
            _this.getBannerList();
            _this.getIndexInfo();
            _this.$wrap.on('click', function (e) {
                let target = $(e.target);
                let type = target.data('type');
                let orderId,timeList;
                switch (type) {
                    case 'more':
                        orderId = target.data('orderId')
                        _this.showMore(orderId);
                        break;
                    case 'detail':
                        timeList = target.data('timeList')
                        _this.showDetail(timeList);
                        break;
                }
            })
        },
        renderTaskName(taskName,subTask){
            if(subTask){
                return taskName+`-`+subTask
            }else {
                return taskName
            }
        },
        showMore(orderId) {
            const _this = this;
            let $box;
            $.get(SERVER + '/index/getOrderMorePlan', {companyId: _this.companyId,orderId:orderId}, function (json) {
                if (json.status == 0) {
                    let messageHtml = `<table class="table table-bordered">
                                     <thead>
                                        <tr>
                                          <th>预计完成时间</th>
                                          <th>实际完成时间</th>
                                          <th>任务</th>
                                          <th>状态</th>
                                        </tr>
                                      </thead>
                                      <tbody>`
                    json.data.forEach((item)=>{
                        messageHtml+=`<tr>
                                        <td>${item.estimateFullfilTime ? util.getYearMonthDaySimple(item.estimateFullfilTime):""}</td>
                                        <td>${item.auditSendTime ?util.getYearMonthDaySimple(item.auditSendTime):""}</td>
                                        <td>${_this.renderTaskName(item.taskName,item.subTask)}</td>
                                        <td>${item.taskStatus && contractStatusArray[item.taskStatus]}</td>
                                      </tr>`
                                      })

                    messageHtml +=    `</tbody>
                                    </table>`;
                    $box = bootbox.dialog({
                        title: '任务列表',
                        message: messageHtml,
                        buttons: {
                            '关闭': (e) => {
                                console.log('提交');
                            }
                        },
                        show: false
                    });
                }
                $box.modal('show');
            });
        },
        showDetail(timeList) {
            let $box;
            let messageHtml = `<table class="table table-bordered">
                                     <thead>
                                        <!--<tr>-->
                                          <!--<th>修改次数</th>-->
                                          <!--<th>预计时间</th>-->
                                      <!---->
                                        <!--</tr>-->
                                      </thead>
                                      <tbody>`
            timeList.forEach((item) => {
                messageHtml += `<tr>
                                        <td>${item[0]}</td>
                                        <td>${item[1] ? util.getYearMonthDaySimple(item[1] ) : ""}</td>
                                      </tr>`
            })
            messageHtml += `</tbody>
                                    </table>`;
            $box = bootbox.dialog({
                title: '预计时间修改列表',
                message: messageHtml,
                buttons: {
                    '关闭': (e) => {
                        console.log('提交');
                    }
                },
                show: false
            });
            $box.modal('show');
        },
        getIndexInfo() {
            let _this = this;
            $.get(SERVER + '/index/getCompanyIndexInfo', {companyId: _this.companyId,sourceType:1}, function (json) {
                if (json.status == 0 && json.data.length>0) {
                    _this.renderIndexInfo(json.data);
                }else {
                    let html = `<div style=" color: #e3e3e3;text-align: center; flex-direction:column;display: flex;justify-content: center"><p style="font-size: 100px;" class="fa fa-sticky-note-o fa-6" aria-hidden="true"></p><p style="">暂无服务中的订单</p></div>`;
                    $(".task-container").html(html)
                }
            });
        },
        renderIndexInfo(data) {
            let html = ``;
            data.forEach((item) => {
                html += `<div class="pin clearfix">
                      <p class="time__line-header">${item.orderName} ${item.isShowMore? `(`+Month+`月)`:""}<span class="pull-right server-time">服务时长：${item.serveDuration} 个月</span>
                        </p>
                        <ul class="time__line">`
                html += this.renderCompanyIndexTaskVoList(item.companyIndexTaskVoList);
                if (item.isShowMore) {
                    html += `</ul>
                            <button class="btn btn-primary btn-xs pull-right" type="button" data-type="more" data-order-id="${item.orderId}">查看更多</button>
                    </div>`;
                } else {
                    html += `</ul></div>`;
                }
            })
            this.$wrap.html(html)
        },
        renderCompanyIndexTaskVoList(companyIndexTaskVoList) {
            const _this = this;
            let dom = `<li class="row line-header time__line-item">
                                <div class="col-md-3">预计完成时间</div>
                                <!--<div class="time__line-item-tail ready"></div>-->
                                <div class="col-md-3">实际完成时间</div>
                                <div class="col-md-4">任务</div>
                                <div class="col-md-2">状态</div>
                            </li>`;
            for (let i =0;i<companyIndexTaskVoList.length;i++){
                    if (companyIndexTaskVoList[i].taskStatus == 4) {
                        dom += `<li class="row time__line-item ready">
                        <div class="col-md-3">${companyIndexTaskVoList[i].estimateFullfilTime ? util.getYearMonthDaySimple(companyIndexTaskVoList[i].estimateFullfilTime) : ""} </div>`
                        if(i<companyIndexTaskVoList.length-1){
                            dom +=`<div class="time__line-item-tail"></div>`

                        }

                        dom +=`<div class="time__line-item-head "></div>
                        <div class="col-md-3"> ${ companyIndexTaskVoList[i].auditSendTime ? util.getYearMonthDaySimple(companyIndexTaskVoList[i].auditSendTime) : ""} </div>
                        <div class="col-md-4">${_this.renderTaskName(companyIndexTaskVoList[i].taskName,companyIndexTaskVoList[i].subTask)}</div>
                        <span class="col-md-2">${ contractStatusArray[companyIndexTaskVoList[i].taskStatus]}</span>
                        </li>`;
                    } else {
                        dom += `<li class="row time__line-item ready">
                        <div class="col-md-3">${companyIndexTaskVoList[i].estimateFullfilTime ? util.getYearMonthDaySimple(companyIndexTaskVoList[i].estimateFullfilTime) : ""} </div>`
                        if(i<companyIndexTaskVoList.length-1){
                            dom +=`<div class="time__line-item-tail"></div>`
                        }
                        dom +=`<div class="time__line-item-head "></div>
                        <div class="col-md-3"> ${ companyIndexTaskVoList[i].auditSendTime ? util.getYearMonthDaySimple(companyIndexTaskVoList[i].auditSendTime) : ""} </div>
                        <div class="col-md-4">${_this.renderTaskName(companyIndexTaskVoList[i].taskName,companyIndexTaskVoList[i].subTask)}</div>`
                        if (companyIndexTaskVoList[i].eftNum > 1) {
                            dom += `<a class="col-md-2 time-detail" data-type="detail" data-time-list=${JSON.stringify(companyIndexTaskVoList[i].estimateFullfilTimeList)}>预计时间已修改</a>`
                        } else {
                            dom += `<span class="col-md-2">${ contractStatusArray[companyIndexTaskVoList[i].taskStatus]}</span>`
                        }
                    }
                    dom += `</li>`;
            }
            return dom;
        },
        getBannerList() {
            const _this = this;
            $.get(SERVER + '/banner/getBannerList', _this.queryObj, (json) => {
                if (json.status == 0) {
                    let html = ``;
                    if (json.data.length > 0) {
                        json.data.forEach(function (item) {
                            html += `<a target="view_window" href="${item.bannerGotoUrl ? item.bannerGotoUrl : '#'}"><div style="width: 100%;height: 100%;background:  url(`+`${SERVER + '/upload/image/' + item.photoUrl}`+`) no-repeat left;"></div></a>`;
                        })
                        _this.$banner.html(html)
                    }else {
                        _this.$banner.html(`     <a target="view_window" href="http://www.51chengxie.com/index" >
                    <div style="width: 100%;height:100%;background:url('../../assets/img/banner.png') no-repeat center"> </div>
                </a>`)
                    }

                    setTimeout(function () {
                        //初始化banner
                        new Banner('#banner', {
                            isAuto: true,
                            isLoop: true,
                            isDir: false
                        });
                    }, 0)
                }
            });
        },
        getNoticeList() {
            let _this = this;
            $.get(SERVER + '/notice/queryNoticePage', _this.queryObj, (json) => {
                if (json.status == 0) {
                    let curPage = _this.$noticeList.data("cpage") ? _this.$noticeList.data("cpage") : 1;
                    let pageCount = json.data.pages;
                    let noticeList = json.data.content;
                    _this.createOrderPage(pageCount, curPage, _this.$noticeList);
                    if (noticeList.length > 0) {
                        _this.renderNoticeList(noticeList, _this.$noticeList);
                    } else {
                        _this.$noticeList.html(_this.emptyHtml);
                    }
                }
            });
        },
        renderNoticeList(noticeList, parentNode) {
            let _this = this;
            parentNode.empty();
            noticeList.forEach(function (element, index, array) {
                parentNode.append(_this.getNoticeItem(element));
            })
        },
        getNoticeItem(element) {
            let html = `<li class="notice-item">
                <a href="/notice-detail.html?noticeId=${element.noticeId}" >
                <div class="notice-header clearfix">
                <span class="notice-title pull-left">${element.title}</span>
                <span class="notice-time pull-right">${util.formatDate(element.createTime)}</span>
                </div>
                </a></li>`;
            return html;
        },
        //创建分页
        createOrderPage(pageCount, curPage, parentNode) {
            //默认5页
            let _this = this;
            let visiblePages = 10,
                pageContainer = $('.page-area'),
                cPage = curPage;
            if (pageCount < visiblePages) {
                visiblePages = pageCount;
            }

            if (pageCount <= 0) {
                pageContainer.html('');
                return;
            }
            pageContainer.find('ul').empty();
            pageContainer.html('<ul class="pagination"></ul>');
            //解绑原来的分页
            if (pageContainer.find('ul').data("twbs-pagination")) {
                cPage = 1;
                pageContainer.twbsPagination('destroy');
            }
            //创建分页
            pageContainer.find('ul').twbsPagination({
                totalPages: pageCount,
                visiblePages: visiblePages,
                first: '首页',
                prev: '上一页',
                next: '下一页',
                last: '尾页',
                startPage: cPage,
                initiateStartPageClick: false,
                onPageClick: function (event, page) {
                    $(parentNode).data("cpage", page);
                    _this.queryObj.number = page;
                    _this.getNoticeList();
                }
            });
        },
    }
    main.ready((userData) => {
        index.init(userData);
    });

}



// WEBPACK FOOTER //
// ./src/pages/index/index.js